import BaseComprobanteInputPipe from "./responses/BaseComprobanteInputPipe";
import ComprobantePagosInputPipe from "./responses/ComprobantePagosInputPipe";
import ComprobanteEgresoInputPipe from "./responses/ComprobanteEgresoInputPipe";
import ComprobanteNominaInputPipe from "./responses/ComprobanteNominaInputPipe";
import ComprobanteAerolineasInputPipe from "./responses/ComprobanteAerolineasInputPipe";
import ComplementoDonatariasInputPipe from "./responses/ComplementoDonatariasInputPipe";
import ComplementoCartaPorteInputPipe from "./responses/ComplementoCartaPorteInputPipe";
import ComplementoVehiculoUsadoInputPipe from "./responses/ComplementoVehiculoUsadoInputPipe";
import ComplementoComercioExteriorInputPipe from "./responses/ComplementoComercioExteriorInputPipe";
import ComplementoImpuestosLocalesInputPipe from "./responses/ComplementoImpuestosLocalesInputPipe";
import ComprobanteIngresoCfdisRelacionadosInputPipe from "./responses/ComprobanteIngresoCfdisRelacionadosInputPipe";

class ProcessCfdiToJsonInputConversion {

  strategies = {};

  defaults() {
    this.register(new ComprobantePagosInputPipe());
    this.register(new ComprobanteEgresoInputPipe());
    this.register(new ComprobanteNominaInputPipe());
    this.register(new ComplementoDonatariasInputPipe());
    this.register(new ComplementoCartaPorteInputPipe());
    this.register(new ComprobanteAerolineasInputPipe());
    this.register(new ComplementoVehiculoUsadoInputPipe());
    this.register(new ComplementoImpuestosLocalesInputPipe());
    this.register(new ComplementoComercioExteriorInputPipe());
    this.register(new ComprobanteIngresoCfdisRelacionadosInputPipe());
    // No mover esta línea de código *sino debes una pizza
    this.register(new BaseComprobanteInputPipe());

    return this;
  }

  register(strategy) {
    this.strategies[strategy.getName()] = strategy;

    return this;
  }

  apply(data, comprobante) {
    for (const strategy of Object.values(this.strategies)) {
      data = strategy.apply(data, comprobante);
    }

    delete data.signature;

    return data;
  }

  static make(data, comprobante) {
    const chain = new this();

    return chain.defaults().apply(data, comprobante);
  }

}

export default ProcessCfdiToJsonInputConversion;